import { FormInstance } from 'antd';
import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useUpdateUser } from '../utils/hooks/useUpdateUser';

interface UpdateUserProps {
  userId: string | undefined;
  action: ReactElement;
  formInstance: FormInstance;
  onSuccess?: () => void;
}

export const UpdateUser: FC<UpdateUserProps> = memo((props) => {
  const { userId, action, formInstance, onSuccess } = props;

  const { t } = useAppTranslation('user');

  const updatedData = formInstance.getFieldsValue();

  const { handleUpdateUser, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useUpdateUser({
    userId,
    updatedData,
    onSuccess,
  });

  const handleClick = useCallback(async (): Promise<void> => {
    try {
      await formInstance.validateFields();
      openConfirmModal();
    } catch (e) {
      console.log(e);
    }
  }, [formInstance, openConfirmModal]);

  return (
    <>
      {React.cloneElement(action, { onClick: handleClick })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Change account details')}
        description={t('Are you sure you want to change account details?')}
        isLoading={isLoading}
        onOk={handleUpdateUser}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
